module.exports = __webpack_public_path__ + "img/322.ad20d014.png";